import { Component, OnInit } from '@angular/core';
import { BookLogicService } from '../../logic/book.service';
import { BookAddModel } from '../../interfaces/interfaces';
import { first, switchMap, mergeAll, map, filter, take } from 'rxjs/operators';
import { Observable, BehaviorSubject, AsyncSubject, Subject } from 'rxjs';
import { PassDataService } from '../../services/pass-data.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { DashboardLogicService } from '../../logic/dashboard.service';

@Component({
  selector: 'app-add-book',
  templateUrl: './add-book.component.html',
  styleUrls: ['./add-book.component.scss']
})
export class AddBookComponent implements OnInit {

  _id: string = '';
  title: string = '';
  description: string = '';
  noOfPages: string = "";
  actualPrice: string = "";
  discountedPrice: string = "";
  buyingLinkShop: string = "";
  buyingLink: string = "";
  reviewLink: string = "";
  imageUrls: string[] = [];
  private files: any = [];
  state: any = '';
  isViewImage: boolean = true;

  filesCount: number[] = [1];

  constructor(
    private bookLogicService: BookLogicService,
    private passDataService: PassDataService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.state = window.history.state;
    if (this.state.data) {
      if (this.state.isEdit || this.state.isView) {
        this.title = this.state.data.title;
        this.description = this.state.data.description;
        this._id = this.state.data._id;
        this.noOfPages = this.state.data.noOfPages;
        this.actualPrice = this.state.data && this.state.data.price.length != 0 ? this.state?.data?.price[0]?.actualPrice : ""
        this.discountedPrice = this.state.data ? this.state.data?.price[0]?.discountedPrice : ""
        this.buyingLinkShop = this.state.data ? this.state.data?.buyingLink[0]?.shop : ""
        this.buyingLink = this.state.data ? this.state.data?.buyingLink[0]?.link : ""
        this.imageUrls = this.state.data.imageUrls
      }
    }
  }

  imageFileOutput(file: any) {
    this.files.push(file.item(0))
  }

  onAddAnotherImage(file: any) {
    this.filesCount.push(this.filesCount.length + 1)
  }

  setTitle(title: string) {
    this.title = title;
  }

  setDescription(description: string) {
    this.description = description;
  }

  setActualPrice(price: string) {
    this.actualPrice = price;
  }

  setBuyingLinkShop(name: string) {
    this.buyingLinkShop = name;
  }

  setDiscountedPrice(price: string) {
    this.discountedPrice = price;
  }

  setNoOfPages(pages: string) {
    this.noOfPages = pages;
  }

  setBuyingLink(link: string) {
    this.buyingLink = link;
  }

  async onAddClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Adding book, please wait!',
    });

    if (this.files.length == null || this.title == '') {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Title and image fields are mandotary',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    const data = await this.bookLogicService
      .addBookLogic(
        this.title,
        this.description,
        this.noOfPages,
        [{
          actualPrice: this.actualPrice,
          discountedPrice: this.discountedPrice,
          currency: "usd"
        }],
        [{
          shop: this.buyingLinkShop,
          link: this.buyingLink,
          text: ""
        }],
        this.files
      )

    if (data?.message == "Book added succesfully") {
      this.router.navigate(['/page/books-list']);
      this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

      this.passDataService.setPopup({
        isPopup: true,
        message: data?.message,
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    } else {

      this.passDataService.setPopup({
        isPopup: true,
        message: 'Error while adding book. pLease try again later.',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    }

  }

  onEditClick() {
    this.state.isEdit = !this.state.isEdit;
    this.state.isView = !this.state.isView;
  }

  async onUpdateClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Updating book info, please wait!',
    });

    if (this.title == '' || this.description == '') {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'All Fields are mandotary!',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    const data = await this.bookLogicService
      .updateBookLogic(
        this._id,
        this.title,
        this.description,
        this.noOfPages,
        [{
          actualPrice: this.actualPrice,
          discountedPrice: this.discountedPrice,
          currency: "usd"
        }],
        [{
          shop: this.buyingLinkShop,
          link: this.buyingLink,
          text: ""
        }],
        this.files,
        this.state.data.imageUrls
      )

    if (data?.message == "Book updated succesfully") {
      this.router.navigate(['/page/books-list']);
      this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

      this.passDataService.setPopup({
        isPopup: true,
        message: data.message,
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    }

  }

  onImageDelete(link: string) {

    this.passDataService.setPopup({
      isPopup: true,
      message: 'Are you sure to delete this image?',
      isOk: false,
      isDelete: true,
      response: '',
    });

    this.passDataService
      .getPopupAction()
      .pipe(
        filter((a) => a != '' || a != null || typeof a != 'undefined'),
        map((b) => b == 'delete'),
        filter((c) => c),
        switchMap(async (d) => {
          this.passDataService.setPopup({
            isPopup: true,
            message: '',
            isOk: false,
            isDelete: false,
            isLoading: true,
            loadingMessage: 'Deleting image, please wait!',
          });
          const data = await this.bookLogicService.deleteBookImageLogic(this._id, link, this.imageUrls)
          return data;
        })
      )
      .subscribe((v: any) => {
        if (v.message == 'success') {
          this.imageUrls = v?.links;
         // console.log("links ", v?.links)
          this.state.data.imageUrls = v?.links
          this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();
          this.passDataService.setPopup({
            isPopup: true,
            message: 'Image deleted successfully!',
            isOk: true,
            isDelete: false,
            response: '',
          });
        } else {
          this.passDataService.setPopup({
            isPopup: true,
            message: 'Error while deleting image. pLease try again later.',
            isOk: true,
            isDelete: false,
            isLoading: false,
            loadingMessage: '',
          });
        }
      });
  }
}
